import { useState, useEffect } from "react";
import UserCards from "../../Components/UsersCards";
import { ViewusersSc } from "./index.sc";
import Navbar from "../../Components/Navbar";
import { getOrgUserDetails } from "../../api/users/getOrgUserDetails";
import { Button, Modal } from "react-bootstrap";
import { Navigate, useNavigate, useParams } from "react-router-dom";
import { useAuthContext } from "../../hooks";
import { deleteOrgUser } from "../../api/users/deleteOrgUser";
import { getOrgUserRoles } from "../../api/users/getOrgUserRoles";
import { useForm } from "react-hook-form";
import { updateOrgUserRols } from "../../api/Update/updateOrgUserRoles";
import { getOrgUserPtoMasterData } from "../../api/LeaveManagement/getUserMasterPto";

function Index() {
  const navigate = useNavigate();
  const params = useParams();
  const auth = useAuthContext();
  const [user, setUser] = useState<any>([]);
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [show1, setShow1] = useState(false);
  const handleShow1 = () => setShow1(true);
  const handleClose1 = () => setShow1(false);
  const [orgUserRoles, setOrgUserRoles] = useState<any[]>([]);
  const {
    register,
    handleSubmit,
    reset,
    setValue,
    formState: { errors },
  } = useForm();
  console.log("------params", params?.orgUserId);
  const fetchOrgUser = async () => {
    if (!params?.orgUserId) return;
    setUser(
      await getOrgUserDetails(auth?.userInfo?.orgs[0]?.id, params?.orgUserId)
    );
    console.log("works");
  };
  const deleteOrgUSer = async () => {
    // if (!params?.orgUserId) return;
    await deleteOrgUser(auth?.userInfo?.orgs[0].id, params?.orgUserId).then(
      () => {
        setShow(false);
        navigate(`..`);
      }
    );
  };
  const [masterData, setMasterData] = useState<any>([]);
  const fetchAllUsersMasterPTO = async () => {
    await getOrgUserPtoMasterData(
      auth?.userInfo?.orgs[0]?.id,
      params?.orgUserId
    )
      .then((e) => {
        console.log(e);
        setMasterData(e);
      })
      .catch((e) => console.log(e));
  };
  console.log("org project", user);
  console.log("i am here", params?.orgUserId);

  useEffect(() => {
    fetchOrgUser();
    fetchAllUsersMasterPTO();
  }, []);
  const fetchOrgUserRoles = async () => {
    await getOrgUserRoles(auth?.userInfo?.orgs[0]?.id)
      .then((e) => {
        console.log(e);
        setOrgUserRoles(e);
      })
      .catch((e) => console.log(e));
  };
  useEffect(() => {
    fetchOrgUserRoles();
  }, []);
  const handleEdit = async (e: any) => {
    console.debug("data > ", e);
    await updateOrgUserRols(auth?.userInfo?.orgs[0]?.id, params?.orgUserId, {
      ...e,
    })
      .then((e) => {
        console.log(e);
      })
      .catch((err) => {
        console.log("====================================");
        console.log(err);
        console.log("====================================");
      });
    fetchOrgUser();
  };

  const onSubmit = async (e: any) => {
    console.log("I am Here", e);
    await handleEdit(e);
    reset();
    setShow(false);
  };
  return (
    <>
      <ViewusersSc>
        <div className="delete-button">
          <Button variant="primary" onClick={() => handleShow1()}>
            Update Role
          </Button>
          <Button variant="danger" onClick={() => handleShow()}>
            Delete User
          </Button>
        </div>
        {user?.map((userData: any) => {
          return (
            <>
              <UserCards
                UserName={userData?.first_name + " " + userData?.last_name}
                Email={userData?.email}
                phone={userData?.phone}
                role={userData?.role}
              />
            </>
          );
        })}
      </ViewusersSc>
      <Modal show={show} onHide={handleClose} backdrop="static">
        <Modal.Header closeButton>
          <Modal.Title>Delete user will delete permanently</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Button onClick={deleteOrgUSer}>Delete User</Button>
        </Modal.Body>
      </Modal>
      <Modal show={show1} onHide={handleClose1} backdrop="static">
        <Modal.Header closeButton>
          <Modal.Title>Update Org Role</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <label>Role</label>
          <form onSubmit={handleSubmit(onSubmit)}>
            {user?.map((userData: any) => {
              return (
                <>
                  <div>
                    <label> Name:</label>{" "}
                    {userData?.first_name + " " + userData?.last_name}
                  </div>
                  <div>
                    {" "}
                    <label>Role: </label>
                    {userData?.role}
                  </div>
                </>
              );
            })}
            <select
              id="org-role"
              className="org-roles"
              {...register("p_designation_id", { required: true })}
            >
              {orgUserRoles?.map((e, i) => {
                return (
                  <>
                    <option value={`${e?.role_id}`} key={i}>
                      {e?.role_name}
                    </option>
                  </>
                );
              })}
            </select>
            <Button type="submit">Change Role</Button>
          </form>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default Index;
